module.exports = __webpack_public_path__ + "img/logo-envato.623e40f9.png";